// extracted by mini-css-extract-plugin
export var email = "share-buttons-module--email--6ac66";
export var linkedin = "share-buttons-module--linkedin--61561";
export var shareButtonsFixed = "share-buttons-module--shareButtonsFixed--e407c";
export var show = "share-buttons-module--show--92b49";
export var twitter = "share-buttons-module--twitter--9048f";